/* Layout */
import Layout from '../../views/layout/Layout.vue'

const DailySalesReport = () => import(/* webpackChunkName: "reports-daily-sales" */ '@/views/report/DailySalesReport')
const MonthlyGMVReport = () => import(/* webpackChunkName: "reports-monthly-gmv" */ '@/views/report/MonthlyGMVReport')
const AdPerformanceReport = () => import(/* webpackChunkName: "reports-ad-performance" */ '@/views/report/AdPerformanceReport')
const SalesReport = () => import(/* webpackChunkName: "reports-sales" */ '@/views/report/SalesReport')
const PrivateClientSalesReport = () => import(/* webpackChunkName: "reports-sales" */ '@/views/report/PrivateClientSalesReport')
const ExportRsSaleReport = () => import(/* webpackChunkName: "reports-export-rs-sale-report" */ '@/views/report/ExportRsSaleReport')
const ExportRsPayoutReport = () => import(/* webpackChunkName: "reports-export-rs-payout-report" */ '@/views/report/ExportRsPayoutReport')
const ExportMpDeliveryReport = () => import(/* webpackChunkName: "reports-export-mp-delivery-report" */ '@/views/report/ExportMpDeliveryReport')

export default [
  {
    path: '/reports',
    component: Layout,
    redirect: 'noredirect',
    name: 'report',
    alwaysShow: true,
    meta: {
      title: 'report',
      icon: 'book-open',
    },
    children: [
      {
        path: 'daily-sales',
        component: DailySalesReport,
        name: 'daily-sales-report',
        meta: {
          title: 'dailySalesReport',
          icon: 'file-alt',
          accessibleName: 'daily-sales-report',
        },
      },
      {
        path: 'monthly-gmv',
        component: MonthlyGMVReport,
        name: 'monthly-gmv-report',
        meta: {
          title: 'monthlyGMVReport',
          icon: 'file-alt',
          accessibleName: 'monthly-gmv-report',
        },
      },
      {
        path: 'ad-performance',
        component: AdPerformanceReport,
        name: 'ad-performance-report',
        meta: {
          title: 'adPerformanceReport',
          icon: 'file-alt',
          accessibleName: 'ad-performance-report',
        },
      },
      {
        path: 'sales',
        component: SalesReport,
        name: 'sales-report',
        meta: {
          title: 'salesReport',
          icon: 'file-alt',
          accessibleName: 'sales-report',
        },
      },
      {
        path: 'private-client-sales',
        component: PrivateClientSalesReport,
        name: 'private-client-sales-report',
        meta: {
          title: 'Private Client Sales',
          icon: 'file-alt',
          accessibleName: 'private-client-sales-report',
        },
      },
      {
        path: 'export-rs-sale-report',
        component: ExportRsSaleReport,
        name: 'export-rs-sale-report',
        meta: {
          title: 'exportRsSaleReport',
          icon: 'download',
          accessibleName: 'export-rs-sale-report',
        },
      },
      {
        path: 'export-rs-payout-report',
        component: ExportRsPayoutReport,
        name: 'export-rs-payout-report',
        meta: {
          title: 'exportRsPayoutReport',
          icon: 'download',
          accessibleName: 'export-rs-payout-report',
        },
      },
      {
        path: 'export-mp-delivery-report',
        component: ExportMpDeliveryReport,
        name: 'export-mp-delivery-report',
        meta: {
          title: 'exportMpDeliveryReport',
          icon: 'download',
          accessibleName: 'export-mp-delivery-report',
        },
      },
    ],
  },
]
